var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21025_3038)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21025_3038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3337 9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332 1.66699 14.6022 1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003 1.6665C14.6027 1.6665 18.3337 5.39746 18.3337 9.99984ZM9.93449 16.6467C9.97441 16.6648 9.99358 16.6664 9.99891 16.6665H10.0017C10.0071 16.6664 10.0262 16.6648 10.0662 16.6467C10.1164 16.6238 10.2029 16.5726 10.3185 16.4638C10.5587 16.2381 10.8507 15.8339 11.1321 15.2084C11.6185 14.1276 11.9765 12.6016 12.0633 10.8332H7.93732C8.02418 12.6016 8.38216 14.1276 8.86858 15.2084C9.14999 15.8339 9.44191 16.2381 9.68216 16.4638C9.79774 16.5726 9.88424 16.6238 9.93449 16.6467ZM7.93732 9.1665H12.0633C11.9765 7.39806 11.6185 5.87207 11.1321 4.79122C10.8507 4.16578 10.5587 3.76161 10.3185 3.5358C10.2029 3.42711 10.1164 3.37582 10.0662 3.35298C10.0262 3.33477 10.007 3.33327 10.0017 3.33317H9.99891C9.99366 3.33327 9.97449 3.33477 9.93449 3.35298C9.88424 3.37582 9.79774 3.42711 9.68216 3.5358C9.44191 3.76161 9.14999 4.16578 8.86858 4.79122C8.38216 5.87207 8.02418 7.39806 7.93732 9.1665ZM12.5187 3.82525C13.1883 5.17473 13.6375 7.05465 13.7318 9.1665H16.6154C16.3128 6.7399 14.7061 4.7183 12.5187 3.82525ZM13.7318 10.8332C13.6375 12.945 13.1883 14.8249 12.5187 16.1744C14.7061 15.2813 16.3128 13.2598 16.6154 10.8332H13.7318ZM7.48194 16.1744C6.81234 14.8249 6.3632 12.945 6.26884 10.8332H3.38523C3.68783 13.2598 5.29458 15.2813 7.48194 16.1744ZM6.26884 9.1665C6.3632 7.05465 6.81234 5.17473 7.48194 3.82525C5.29458 4.7183 3.68783 6.7399 3.38523 9.1665H6.26884Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21025_3038)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21025_3038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.6b5c0bfb378ce4ec0bdd1b58ac4046a6.svg";
export { ForwardRef as ReactComponent };